import { CMSProductShelf } from '@/features/cms/components/CMS/components/Shelves/ProductShelf/CMSProductShelf'
import { type cmsComponents } from '@/features/cms/components/CMS/CMSComponents'

export const layoutEagerComponents: Partial<typeof cmsComponents> = {
  product_shelf: CMSProductShelf,
} as const
